export default __webpack_public_path__ + "images/03dde9ee48ff220ecd55387dfb1b88a6.png";